import { render, staticRenderFns } from "./RepresentativesModal.vue?vue&type=template&id=489e071a&"
import script from "./RepresentativesModal.vue?vue&type=script&lang=js&"
export * from "./RepresentativesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports